/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { PageQueryParams, SearchQueryParams } from '../apiCommon.typings';
import { UiType, UserRole } from '../auth/authClient.typings';

export interface UserDto {
    id: number;
    firstName: string;
    lastName: string;
}

export enum LoginFormType {
    Inspector = 'INSPECTOR',
    Operator = 'OPERATOR',
    Taxpayer = 'TAXPAYER',
}

export interface DetailedUserDto {
    id: number;
    status: UserStatus;
    firstName: string;
    lastName: string;
    middleName?: string;
    registrationAtUtc: string;
    deactivationDate?: string;
    email: string;
    phone?: string;
    uiType: UiType;
    roles: UserRole[];
    operatorName?: string; // for operators
    taxAuthorityId?: string; // for inspectors
    department?: string; // for inspectors
    avisName?: string; // for inspectors

    [key: string]: number | string | UiType | UserRole[];
}

export interface DetailedUsersListDto {
    count: number;
    users: DetailedUserDto[];
}

export enum UserStatus {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
    Deleted = 'DELETED',
}

export type DetailedUsersListQueryParams = PageQueryParams & DetailedUsersListFilterParams;

export interface DetailedUsersListFilterParams extends Partial<SearchQueryParams> {
    status?: UserStatus[];
    uiType?: UiType[];
    roles?: UserRole[];
    taxAuthorityId?: string[];
    operatorTaxNumber?: string[];
}

//for added and edited users
export interface NewUserData {
    firstName: string;
    middleName?: string;
    lastName: string;
    email: string;
    phone?: string;
    uiType: UiType;
    roles: UserRole[];
    taxAuthorityId?: string;
    department?: string;
    avisName?: string;
    password: string;

    [key: string]: string | UiType | UserRole[];
}
